import { Button, Image } from "@components/anti"
import { currencyFormatter } from "lib/utils/utils"
import React from "react"
// import Image from "next/image"
import { useWindowSize } from "@components/hooks/hooks"
import {
  F_M_DELETE_CART,
  F_M_UPDATE_BAG,
  F_Q_CARTS,
  sendDatalayerProduct,
} from "lib/function"
import { SET_CARTS } from "lib/redux/types"
import { useDispatch } from "react-redux"
import CustomQty from "@components/global/custom-qty/custom-qty"

export const BagItem = ({
  image,
  price,
  sell_price,
  product_id,
  quantity,
  sku_id,
  title,
  stock,
  id,
  locale,
  carts,
  token,
  index,
}) => {
  const datalayerData = {
    id: product_id,
    title,
    price,
    sell_price,
    listName: "Cart",
    index,
  }
  const { width } = useWindowSize()
  const isMobile = width < 768

  //States
  const [state, setState] = React.useState({
    qty: quantity,
    stock,
  })
  const dispatch = useDispatch()

  //Functions *************************************************************************** //
  const handleDeleteCart = async (e, id) => {
    e.preventDefault()
    let { data, errors } = await F_M_DELETE_CART({ id, lang: locale })
    if (data?.deleteCart?.status === "success") {
      let { data, errors } = await F_Q_CARTS({ lang: locale }, token)
      if (data && data?.carts?.status === "success") {
        sendDatalayerProduct({
          event: "remove_from_cart",
          data: { ...datalayerData, quantity: state.qty },
          type: 2,
        })
        dispatch({ type: SET_CARTS, payload: data?.carts })
      } else {
        //!NEED ERROR HANDLING
      }
    }
    if (errors) console.log(errors)
  }

  const handleClick = async (type) => {
    if (type === "inc") {
      if (state.qty < stock) {
        setState((prev) => ({ ...prev, qty: state.qty + 1, btnDis: true }))
        let { data, errors } = await F_M_UPDATE_BAG({
          id: id,
          quantity: Number(state.qty + 1),
        })
        if (data) {
          let { updateCart } = data
          if (updateCart) {
            dispatch({ type: SET_CARTS, payload: updateCart })
            setState((prev) => ({ ...prev, btnDis: false }))
            sendDatalayerProduct({
              event: "add_to_cart",
              data: datalayerData,
              type: 2,
            })
          } else {
          }
        } else {
          //!NEED ERROR HANDLING
          setState((prev) => ({ ...prev, btnDis: false }))
        }
      }
    } else if (type === "dec") {
      if (state.qty > 1) {
        setState((prev) => ({ ...prev, qty: state.qty - 1 }))
        let { data, errors } = await F_M_UPDATE_BAG({
          id: id,
          quantity: Number(state.qty - 1),
        })
        if (data) {
          let { updateCart } = data
          if (updateCart) {
            dispatch({ type: SET_CARTS, payload: updateCart })
            setState((prev) => ({ ...prev, btnDis: false }))
            sendDatalayerProduct({
              event: "remove_from_cart",
              data: datalayerData,
              type: 2,
            })
          } else {
          }
        } else {
          //!NEED ERROR HANDLING
          setState((prev) => ({ ...prev, btnDis: false }))
        }
      }
    } else if (typeof type === "number") {
      const qtyBefore = state.qty
      setState((prev) => ({ ...prev, qty: type }))
      let { data, errors } = await F_M_UPDATE_BAG({
        id: id,
        quantity: Number(type),
      })
      if (data) {
        let { updateCart } = data
        if (updateCart) {
          dispatch({ type: SET_CARTS, payload: updateCart })
          sendDatalayerProduct({
            event: qtyBefore < type ? "add_to_cart" : "remove_from_cart",
            data: {
              ...datalayerData,
              quantity: qtyBefore < type ? type - qtyBefore : qtyBefore - type,
            },
            type: 2,
          })
        } else {
        }
      } else {
        //!NEED ERROR HANDLING
      }
    }
  }
  //Functions *************************************************************************** //

  return (
    <>
      <div className="bag-item">
        <Image src={image} alt="img-card-product" ratio="r-4-5" />
        <div className="bag-item__content">
          <div className="bag-item__desc">
            <h3 className="title">{title}</h3>
            <span
              className="ail ai-trash-alt"
              role="button"
              tabIndex={0}
              onClick={(e) => handleDeleteCart(e, id)}
            />
          </div>

          <div className="bag-item__qty-md">
            <div className="wrapper-price">
              <h6 className="price-label">
                {locale === "id" ? "Harga Satuan" : "Price each"}
              </h6>
              <h6 className="price-value">
                {currencyFormatter("ID", sell_price)}
              </h6>
            </div>
            <div className="wrapper-qty">
              <CustomQty
                handleClickQty={handleClick}
                qty={state.qty}
                stock={state.stock}
              />
            </div>
          </div>
        </div>

        <div className="bag-item__qty">
          <div className="wrapper-price">
            <h6 className="price-label">
              {locale === "id" ? "Harga Satuan" : "Price each"}
            </h6>
            <h6 className="price-value">
              {currencyFormatter("ID", sell_price)}
            </h6>
          </div>
          <div className="wrapper-qty">
            <CustomQty
              handleClickQty={handleClick}
              qty={state.qty}
              stock={state.stock}
            />
          </div>
        </div>
      </div>
    </>
  )
}
